import styled from "styled-components";

const Wrapper = styled.div`
  .scroll-to-top {
    position: fixed;
    bottom: 100px; /* Aligned above WhatsApp */
    right: 25px;   /* Exactly same as WhatsApp desktop */
    background-color: var(--primary-color);
    color: var(--secondary-color);
    border: 3px solid white; /* Same border style as WhatsApp for consistency */
    border-radius: 50%;
    width: 60px;  /* Same as WhatsApp desktop */
    height: 60px; /* Same as WhatsApp desktop */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.5rem; /* Larger arrow */
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    transition: var(--transition);
    z-index: 998;

    &:hover {
      background-color: var(--secondary-color);
      color: var(--primary-color);
      transform: scale(1.1) translateY(-5px);
       box-shadow: 0 15px 30px rgba(15, 44, 89, 0.2);
    }

    &:active {
      transform: translateY(-2px);
    }

    @media (max-width: 600px) {
      bottom: 85px;
      right: 20px; /* Match mobile WhatsApp right */
      width: 55px;  /* Match mobile WhatsApp width */
      height: 55px; /* Match mobile WhatsApp height */
      font-size: 1.3rem;
    }
  }
`;

export default Wrapper;
